import React from "react";
import Avatar from "../shared/Avatar";
import Badge from "../shared/Badge";
import Card from "../shared/Card";

const PanelistsList = ({ panelists = [] }) => {
  return (
    <Card
      title="Assigned Panelists"
      headerAction={
        <span className="text-sm text-gray-500">
          {panelists.length} members
        </span>
      }
    >
      {panelists.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p>No panelists have been approved yet.</p>
          <p className="text-sm mt-2">
            Panelists will appear here once approved by the committee and
            client.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {panelists.map((panelist, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <div className="flex items-center">
                <Avatar name={panelist.name} size="md" className="mr-3" />
                <div>
                  <p className="font-medium text-gray-900">{panelist.name}</p>
                  <p className="text-sm text-gray-600">
                    {panelist.expertise?.join(", ") || "No expertise listed"}
                  </p>
                </div>
              </div>
              <div className="text-right">
                {panelist.yearsExperience && (
                  <p className="text-sm text-gray-500">
                    {panelist.yearsExperience} years exp.
                  </p>
                )}
                {panelist.status && (
                  <Badge variant="success" size="sm" className="mt-1">
                    {panelist.status}
                  </Badge>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default PanelistsList;
